module.exports = __webpack_public_path__ + "img/icon-06.34a61cb0.png";